export default {
  api: 'https://api.pre-prod.cx.curvo.cloud/graphql',
  agGridLicense:
    '',
  supplierPortalBaseUrl: 'https://activate.curvolabs.com',
  entraTenantId: '366a7b98-c559-4599-a8c2-a244af0e5596',
  entraClientId: '853a41df-d9fe-45e1-b625-518344086bef',
  entraAuthorityHost: 'https://cbjssoprod.ciamlogin.com',
  useHubspot: false,
  useHeap: false,
  launchDarklyClientId:
    '642a8c28bdd73812d6f1d334',
  planeHostUrl: 'https://dev.plane.curvo.cloud',
  broadjumpBaseUrl: 'https://portal.broadjumpllc.com',
}
